<template>
    <div style="background:#F4F4F4; padding: 16px;">
        <el-row :gutter="20">
            <el-col class="queryform" :span="24">
                <el-form :inline="true" :model="queryform" class="demo-form-inline toolbar"
                    style="color:#111111; margin-bottom: 16px;" @submit.native.prevent>
                    <el-form-item label="老人姓名">
                        <el-input v-model="queryform.oldName" placeholder="请输入老人姓名" clearable
                            @keyup.enter.native.prevent="getOldFeeStaticList"></el-input>
                    </el-form-item>
                    <el-form-item label="老人身份证">
                        <el-input v-model="queryform.oldmanIdCard" placeholder="请输入老人身份证" clearable
                            @keyup.enter.native.prevent="getOldFeeStaticList"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="font-size:13px" icon="el-icon-search" size="small" plain
                            @click="getOldFeeStaticList">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" style="font-size:13px" icon="el-icon-delete" size="small" plain
                            @click="handleCleanOldBindFee">清空费用</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="warning" style="font-size:13px" size="small" plain
                            @click="openGenerateDialog">生成月度缴费单</el-button>
                    </el-form-item>
                    <el-button type="info" @click="toLead" icon="el-icon-upload" plain>表格导入</el-button>
                </el-form>
            </el-col>

            <el-col :span="24">
                <el-table :data="tableData"
                    :header-cell-style="{ 'text-align': 'center', 'font-weight': '600', color: '#2d2d2d', 'background-color': '#d4f5fa' }"
                    :cell-style="{ 'text-align': 'center', 'font-size': '13px' }"
                    :row-style="tableRowStyle"
                    border style="width: 100%; background: #fff;">
                    <el-table-column prop="oldmanName" label="姓名" width="80px" align="center"></el-table-column>
                    <el-table-column prop="oldIdCard" label="身份证号" width="160px" align="center"></el-table-column>
                    <el-table-column prop="registryTime" label="入院日期" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="bedFee" label="床位费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.bedFee ? scope.row.bedFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="careFee" label="护理费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.careFee ? scope.row.careFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="foodFee" label="餐饮费" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.foodFee ? scope.row.foodFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="otherName" label="其他费用名称" min-width="120px" align="center">
                        <template slot-scope="scope">{{ scope.row.otherName || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="otherFee" label="其他费用金额" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.otherFee ? scope.row.otherFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="totalFee" label="费用合计" min-width="80px" align="center">
                        <template slot-scope="scope">{{ scope.row.totalFee ? scope.row.totalFee.toFixed(2) : '0.00' }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="150px" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    style="color:#333; text-align: center; margin-top:15px;"
                    background layout="total, prev, pager, next"
                    :total="total" :page-size="pageSize" :current-page="pageNum"
                    @current-change="changePage">
                </el-pagination>
            </el-col>
        </el-row>

        <!-- 生成月度缴费单弹窗 -->
        <el-dialog title="生成月度缴费单" :visible.sync="generateDialogVisible"
            width="360px" :close-on-click-modal="false">
            <el-form label-width="80px">
                <el-form-item label="账单月份">
                    <el-date-picker
                        v-model="generateYearMonth"
                        type="month"
                        placeholder="选择月份"
                        value-format="yyyy-MM"
                        style="width: 200px;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="generateDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="generateLoading" @click="generateMonthFee">确认生成</el-button>
            </div>
        </el-dialog>

        <!-- 清理确认弹窗 -->
        <el-dialog title="警告：清理月度绑定记录" :visible.sync="cleanDialogVisible"
            width="400px" :close-on-click-modal="false" :before-close="handleDialogClose">
            <div style="color: #f56c6c; margin-bottom: 16px;">
                此操作将删除【{{ queryform.oldName || '所有老人' }}】的月度费用绑定记录，数据删除后不可恢复！
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cleanDialogVisible = false">取消</el-button>
                <el-button type="danger" @click="submitCleanOldBindFee">确认清理</el-button>
            </div>
        </el-dialog>

        <!-- 编辑费用弹窗 -->
        <el-dialog title="编辑老人费用绑定" :visible.sync="editDialogVisible"
            width="880px" :close-on-click-modal="false">
            <el-table :data="editFeeList" border size="small"
                :header-cell-style="{ 'text-align': 'center', 'background-color': '#f5f7fa' }"
                :cell-style="{ 'text-align': 'center' }">
                <el-table-column prop="typeName" label="费用类型" min-width="100px"></el-table-column>
                <el-table-column prop="itemName" label="费用项目" min-width="100px"></el-table-column>
                <el-table-column label="金额（元）" min-width="130px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.chargeStandard"
                            :min="0" :precision="2" size="small" style="width:180px">
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="删除" width="60px">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" icon="el-icon-delete" circle
                            @click="handleDeleteOne(scope.row, scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitEdit">保存</el-button>
            </div>
        </el-dialog>

        <!-- 报表上传 -->
        <el-dialog title="月度费用导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false">
            <el-row type="flex" justify="center">
                <el-col :span="20">
                    <el-row>
                        <el-col :span="24">
                            <input type="file" ref="file" id="file" @change="getUrl" />
                        </el-col>
                    </el-row>
                    <el-button type="primary" size="mini" @click="downMoban" style="margin-top: 40px;">导入模版下载</el-button>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click.native="toLeadVisisble = false">取消</el-button>
                <el-button type="primary" @click.native="intoForm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
export default {
    name: "financeOldMonthFeeBind",
    data() {
        return {
            queryform: { oldName: '', oldmanIdCard: '', monthStr: '' },
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            cleanDialogVisible: false,
            generateDialogVisible: false,
            generateYearMonth: null,
            generateLoading: false,
            toLeadVisisble: false,
            toLeadForm: null,
            fileFlag: false,
            // 编辑弹窗
            editDialogVisible: false,
            editOldId: null,
            editFeeList: [],
            deletedIds: [],
        };
    },
    methods: {
        toLead() {
            this.uploadFile = null;
            this.toLeadVisisble = true;
        },
        getUrl(event) {
            let file = event.target.files;
            this.fileFlag = true;
            this.toLeadForm = new FormData();
            this.toLeadForm.append("file", file[0]);
        },
        downMoban() {
            window.location.href = baseURL + `fmc/export/bindFeeTemplate`;
        },
        intoForm() {
            if (this.fileFlag) {
                this.$postFormData("fmc/elderFeeConfig/importFee", this.toLeadForm).then((res) => {
                    this.toLeadVisisble = false;
                    this.fileFlag = false;
                    this.toLeadForm = {};
                    if (res.code == 200) {
                        this.$message({ message: res.message, type: "success" });
                        this.getOldFeeStaticList();
                    } else {
                        this.$message({ message: res.message, type: "error" });
                    }
                });
            } else {
                this.$message({ message: "请选择文件", type: "error" });
            }
        },
        changePage(val) {
            this.pageNum = val;
            this.getOldFeeStaticList();
        },
        tableRowStyle({ rowIndex }) {
            return rowIndex % 2 === 0
                ? { "background-color": "#ffffff" }
                : { "background-color": "#e4f5f8" };
        },
        getOldFeeStaticList() {
            const param = {
                oldName: this.queryform.oldName,
                oldmanIdCard: this.queryform.oldmanIdCard,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            this.$postJson("fmc/elderFeeConfig/queryFeeStatic", param).then((res) => {
                if (res.code == 200 && res.result) {
                    this.tableData = res.result.list || [];
                    this.total = Number(res.result.total) || 0;
                } else {
                    this.$message.error("查询失败：" + (res.message || "未知错误"));
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        openGenerateDialog() {
            // 默认当月
            const now = new Date();
            const mm = String(now.getMonth() + 1).padStart(2, '0');
            this.generateYearMonth = `${now.getFullYear()}-${mm}`;
            this.generateDialogVisible = true;
        },
        generateMonthFee() {
            if (!this.generateYearMonth) {
                this.$message.warning("请选择账单月份");
                return;
            }
            this.generateLoading = true;
            this.$postJson("fmc/account/generateMonthFee", { yearMonth: this.generateYearMonth }).then((res) => {
                this.generateLoading = false;
                if (res.code == 200) {
                    this.$message.success("生成成功");
                    this.generateDialogVisible = false;
                    this.getOldFeeStaticList();
                } else {
                    this.$message.error(res.message || "未知错误");
                }
            }).catch(() => {
                this.generateLoading = false;
            });
        },
        handleCleanOldBindFee() {
            this.cleanDialogVisible = true;
        },
        submitCleanOldBindFee() {
            const param = {
                oldName: this.queryform.oldName,
                oldmanIdCard: this.queryform.oldmanIdCard,
            };
            this.$postJson("fmc/elderFeeConfig/clean", param).then((res) => {
                this.cleanDialogVisible = false;
                if (res.code == 200) {
                    this.$message.success("清理成功");
                    this.getOldFeeStaticList();
                } else {
                    this.$message.error("清理失败：" + (res.message || "未知错误"));
                }
            });
        },
        handleDialogClose() {
            this.cleanDialogVisible = false;
        },

        // 编辑：打开弹窗，加载该老人费用列表
        handleEdit(row) {
            this.editOldId = row.oldId;
            this.deletedIds = [];
            this.$postJson("fmc/elderFeeConfig/queryBindFeeList", { oldId: row.oldId }).then((res) => {
                if (res.code == 200 && res.result) {
                    this.editFeeList = res.result.map(item => Object.assign({}, item));
                    this.editDialogVisible = true;
                } else {
                    this.$message.error("获取费用列表失败");
                }
            });
        },
        // 弹窗内单行标记删除
        handleDeleteOne(row, index) {
            if (row.id) this.deletedIds.push(row.id);
            this.editFeeList.splice(index, 1);
        },
        // 提交编辑：并行执行删除+更新
        submitEdit() {
            const promises = [];
            this.deletedIds.forEach(id => {
                promises.push(this.$postJson("fmc/elderFeeConfig/deleteOne", { id }));
            });
            this.editFeeList.forEach(item => {
                if (item.id) {
                    promises.push(this.$postJson("fmc/elderFeeConfig/updateOne", {
                        id: item.id,
                        amount: item.chargeStandard,
                    }));
                }
            });
            Promise.all(promises).then(() => {
                this.$message.success("保存成功");
                this.editDialogVisible = false;
                this.getOldFeeStaticList();
            }).catch(() => {
                this.$message.error("保存失败，请重试");
            });
        },

        // 整行删除：删除该老人所有费用绑定
        handleDelete(row) {
            this.$confirm(`确定删除【${row.oldmanName}】的所有费用绑定吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$postJson("fmc/elderFeeConfig/clean", { oldId: row.oldId }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success("删除成功");
                        this.getOldFeeStaticList();
                    } else {
                        this.$message.error(res.message || "删除失败");
                    }
                });
            }).catch(() => {});
        },
    },
    mounted() {
        this.getOldFeeStaticList();
    },
};
</script>

<style scoped>
.demo-form-inline .el-form-item {
    margin-right: 16px;
    margin-bottom: 12px;
}
.el-table--border th, .el-table--border td {
    border-right: 1px solid #e4e7ed;
}
</style>
